/**
 * @file 获取问卷
 * @author liudy
 * @see http://api.umucdn.cn/project/106/wiki
 */

import Api from '../../path';
import { PollType } from '@umu/umu-types';
import { fetchData } from '@umu/umu-fetch';

export enum PollBaseType {
    POLL_QUESTION = 0, // 0、获取问卷所有的问题信息
    POLL_BASE_INFO = 1, // 1、获取问卷基本信息
}

export interface IGetPollInput {
    id: number; // int 对应id
    parent_type: PollType; // int 1、问卷模板 2、问卷 4、企业模版
    get_base: PollBaseType; // int 1、只获取问卷基本信息 0、获取问卷所有的问题信息
    page: number; // int 获取全部传0，否则按分页取数据
    size: number; // int
}

export interface IGetPollOutput {
    id: number;
    title: string;
    parent_type: PollType;
    question_num: number;
    paragraph_nber: number;
    create_ts: number;
    update_ts: number;
    list: any[]; // todo
}

export const getPoll = (data: IGetPollInput): Promise<IResponse<IGetPollOutput>> => {
    return fetchData(Api.POLL_GET, data);
};
